import { theme, Typography } from "kosmos-ui/lib";

import { useLayout } from "app/context/LayoutContext/hooks";
import PosterCard from "app/components/PosterCard";
import CustomerProfileImg from "app/assets/images/customer-profile.png";
import CustomersSectionImg from "app/assets/images/customers-section.png";
import CategoriesCollageImg from "app/assets/images/categories-collage.png";

import {
  ValuePropositionSectionContainer,
  ValuePropositionSubsectionContainer,
  ValuePropositionImg,
} from "./styles";

export default function ValuePropositionSection() {
  const { mobile, topbarHeight, announcementBarHeight } = useLayout();

  const headerHeight = topbarHeight + announcementBarHeight;

  return (
    <>
      <ValuePropositionSectionContainer>
        <PosterCard
          bgImg={CategoriesCollageImg}
          style={{
            height: "50vh",
            maxHeight: 440,
            maxWidth: 1200 - 144,
            marginTop: headerHeight,
          }}
        >
          <Typography as="h1" variant="title1">
            Entra a Grafito.
          </Typography>

          <Typography
            as="h2"
            variant="paragraph1"
            style={{
              color: theme.colorsPalette.white.default,
              maxWidth: 560,
              fontWeight: theme.fontWeights.bold,
            }}
          >
            Somos la primera plataforma enfocada en conectar creadores
            nacionales con su audiencia, llevando al siguiente nivel la
            experiencia de compra.
          </Typography>
        </PosterCard>

        <ValuePropositionSubsectionContainer>
          <PosterCard
            gradientFrom="#cd41b4"
            gradientTo="#5f0ec7"
            style={{
              maxHeight: 440,
              maxWidth: 1200 - 144,
              marginRight: 16,
            }}
          >
            <Typography as="h1" variant="title2">
              Verás lo que <br /> no se ve.
            </Typography>

            <Typography
              as="h2"
              variant="paragraph1"
              style={{
                color: theme.colorsPalette.white.default,
                maxWidth: 560,
                fontWeight: theme.fontWeights.bold,
              }}
            >
              Datos de todas las variables, para que en tiempo real te informes
              como va tu negocio.
            </Typography>

            <Typography
              as="h2"
              variant="paragraph1"
              style={{
                color: theme.colorsPalette.white.default,
                maxWidth: 560,
                fontWeight: theme.fontWeights.bold,
              }}
            >
              Maneja tus productos, órdenes, despachos, promociones y tienda
              virtual de manera fácil e intuitiva.
            </Typography>
          </PosterCard>

          <PosterCard
            gradientFrom="#cd41b4"
            gradientTo="#5f0ec7"
            style={{
              maxHeight: 440,
              maxWidth: 1200 - 144,
              marginTop: mobile ? 16 : 0,
            }}
          >
            <Typography as="h1" variant="title2">
              Una verdadera experiencia de compra.
            </Typography>

            <Typography
              as="h2"
              variant="paragraph1"
              style={{
                color: theme.colorsPalette.white.default,
                maxWidth: 560,
                fontWeight: theme.fontWeights.bold,
              }}
            >
              Tus seguidores podrán registrarse y disfrutar de contenido
              exclusivo de tu marca, recibir recomendaciones inteligentes y
              comprar a través de una tienda virtual fresca, intuitiva y simple.
            </Typography>
          </PosterCard>
        </ValuePropositionSubsectionContainer>

        <ValuePropositionSubsectionContainer style={{ marginTop: 16 }}>
          <PosterCard
            gradientFrom="#cd41b4"
            gradientTo="#5f0ec7"
            style={{
              minHeight: `calc(50vh - ${4 * topbarHeight}px)`,
              maxHeight: 440,
              maxWidth: 1200 - 144,
            }}
          >
            <Typography as="h1" variant="title2" style={{ maxWidth: 320 }}>
              Tus productos encontrarán <br /> a tus seguidores.
            </Typography>

            <Typography
              as="h2"
              variant="paragraph1"
              style={{
                color: theme.colorsPalette.white.default,
                maxWidth: 320,
                fontWeight: theme.fontWeights.bold,
              }}
            >
              Conecta con nuevos clientes donde sea que estén. Conoce en
              profundidad su frecuencia, preferencias, impulsos. Llega a ellos
              en el momento indicado y con lo que realmente están buscando.
            </Typography>
            {!mobile && (
              <>
                <ValuePropositionImg
                  src={CustomersSectionImg}
                  style={{
                    right: 64,
                    bottom: 92,
                  }}
                />

                <ValuePropositionImg
                  src={CustomerProfileImg}
                  style={{
                    right: 104,
                    bottom: 42,
                    height: 320,
                  }}
                />
              </>
            )}
          </PosterCard>
        </ValuePropositionSubsectionContainer>
      </ValuePropositionSectionContainer>
    </>
  );
}
